<div class="card glowing-card shadow rounded-4 p-3">
  <div class="card-body p-0">
    <div class="onboarding-stepper">
      @for (step of steps; track step; let i = $index; let last = $last) {
        <div class="step-item">
          <div class="step-track">
            <!-- Circle -->
            <div class="step-circle" [class.active]="isActive(step)" [class.completed]="isCompleted(step)">
              <!-- Completed: show tick -->
              @if (isCompleted(step)) {
                <i class="fas fa-check"></i>
              }
              <!-- Not completed: show step icon -->
              @if (!isCompleted(step)) {
                @switch (step.icon) {
                  @case ('user-plus') {
                    <app-user-plus-icon [width]="20" [height]="20"
                    color="currentColor"></app-user-plus-icon>
                  }
                  @case ('club-details') {
                    <app-club-details-icon [width]="20" [height]="20"
                    color="currentColor"></app-club-details-icon>
                  }
                  @case ('eye') {
                    <app-eye-icon [width]="20" [height]="20"
                    color="currentColor"></app-eye-icon>
                  }
                }
              }
            </div>
            <!-- Connector line (not on last step) -->
            @if (!last) {
              <div class="step-connector" [class.completed]="isConnectorCompleted(step)"></div>
            }
          </div>
          <!-- Text -->
          <div class="step-info">
            <span class="step-label">STEP {{ step.number }}</span>
            <span class="step-title">{{ step.label }}</span>
          </div>
        </div>
      }
    </div>
  </div>
</div>